import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import {
  FaArrowDown,
  FaArrowUp,
  FaCheck,
  FaGripVertical,
  FaSort,
  FaTimes,
} from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const MODAL_RADIUS = 16;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-arrange-subject-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 760px;
  }
  .mdl-arrange-subject-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-arrange-subject-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-arrange-subject-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-arrange-subject-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-arrange-subject-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-arrange-subject-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mars-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mars-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mars-title__text { min-width: 0; }
  .mars-title__main {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
  }
  .mars-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
    line-height: 1.3;
  }
  .mars-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;
  }
  .mars-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 26px;
    padding: 3px 10px;
    border-radius: 999px;
    border: 1px solid #b3e5fc;
    background: #e1f5fe;
    color: #01579b;
    font-size: 11px;
    font-weight: 700;
  }
  .mars-hint {
    margin: 0 0 10px;
    font-size: 12px;
    font-weight: 600;
    color: #607d8b;
  }
  .mars-list {
    max-height: 360px;
    overflow-y: auto;
    display: grid;
    gap: 8px;
    padding: 2px;
  }
  .mars-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
    cursor: grab;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
    user-select: none;
  }
  .mars-item:active { cursor: grabbing; }
  .mars-item.is-dragging {
    opacity: 0.55;
    border-color: #0288d1;
    background: #e1f5fe;
    box-shadow: 0 4px 12px rgba(2, 136, 209, 0.14);
  }
  .mars-item__grip {
    color: #90a4ae;
    font-size: 14px;
    flex-shrink: 0;
  }
  .mars-item__order {
    width: 26px;
    height: 26px;
    border-radius: 999px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e1f5fe;
    border: 1px solid #b3e5fc;
    color: #01579b;
    font-size: 11px;
    font-weight: 800;
  }
  .mars-item__body { min-width: 0; flex: 1; }
  .mars-item__name {
    display: block;
    font-size: 13px;
    font-weight: 800;
    color: #01579b;
    line-height: 1.25;
  }
  .mars-item__code {
    display: inline-flex;
    margin-top: 3px;
    padding: 1px 7px;
    border-radius: 999px;
    background: #e1f5fe;
    border: 1px solid #b3e5fc;
    color: #0277bd;
    font-size: 10px;
    font-weight: 700;
  }
  .mars-item__actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }
  .mars-move {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    background: #fff;
    color: #0288d1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 11px;
  }
  .mars-move:hover:not(:disabled) {
    background: #e1f5fe;
    border-color: #4fc3f7;
    color: #01579b;
  }
  .mars-move:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  .mars-empty {
    text-align: center;
    padding: 36px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
  }
  .mars-empty__title {
    margin: 0;
    font-size: 14px;
    font-weight: 800;
    color: #455a64;
  }
  .mars-empty__hint {
    margin: 4px 0 0;
    font-size: 12px;
    color: #78909c;
  }
  .mars-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mars-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .mars-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mars-btn--ghost:hover:not(:disabled) {
    background: #e1f5fe;
  }
  .mars-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
  .mars-btn--primary:hover:not(:disabled) {
    filter: brightness(1.03);
  }
`;

//Created By Cursor
function classLabel(classItem) {
  if (!classItem) return "Class";
  if (classItem.section_id === "No" || !classItem.section_name) {
    return classItem.class_name || "Class";
  }
  return `${classItem.class_name} - ${classItem.section_name}`;
}

const MdlArrangeSubjects = ({
  show,
  onHide,
  classItem,
  allSubjects = [],
  examId,
  onSaved,
}) => {
  const [arrangedSubjects, setArrangedSubjects] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-arrange-subject", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, [show]);

  useEffect(() => {
    if (!show || !classItem) return;

    const currentSection = classItem.section_id ?? "No";
    const filtered = Array.isArray(allSubjects)
      ? allSubjects.filter((s) =>
          currentSection === "No"
            ? true
            : String(s.section_id) === String(currentSection)
        )
      : [];

    const orderIds = String(classItem.subject_ids || "")
      .split(",")
      .map((id) => id && String(id).trim())
      .filter(Boolean);

    if (orderIds.length > 0) {
      const indexById = new Map(orderIds.map((id, idx) => [id, idx]));
      const sorted = [...filtered].sort((a, b) => {
        const ia = indexById.has(a.subject_id)
          ? indexById.get(a.subject_id)
          : Number.MAX_SAFE_INTEGER;
        const ib = indexById.has(b.subject_id)
          ? indexById.get(b.subject_id)
          : Number.MAX_SAFE_INTEGER;
        return ia - ib;
      });
      setArrangedSubjects(sorted);
    } else {
      setArrangedSubjects(filtered);
    }
  }, [show, classItem, allSubjects]);

  //Created By Cursor
  const handleDragStart = useCallback((e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", String(index));
  }, []);

  //Created By Cursor
  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }, []);

  //Created By Cursor
  const handleDragEnd = useCallback(() => {
    setDraggedIndex(null);
  }, []);

  //Created By Cursor
  const handleDrop = useCallback(
    (e, dropIndex) => {
      e.preventDefault();
      const fromIndex =
        draggedIndex ?? Number(e.dataTransfer.getData("text/plain"));
      if (
        fromIndex === null ||
        Number.isNaN(fromIndex) ||
        fromIndex === dropIndex
      ) {
        return;
      }
      setArrangedSubjects((prev) => {
        const next = [...prev];
        const [moved] = next.splice(fromIndex, 1);
        next.splice(dropIndex, 0, moved);
        return next;
      });
      setDraggedIndex(null);
    },
    [draggedIndex]
  );

  //Created By Cursor
  const moveUp = useCallback((index) => {
    if (index <= 0) return;
    setArrangedSubjects((prev) => {
      const next = [...prev];
      [next[index - 1], next[index]] = [next[index], next[index - 1]];
      return next;
    });
  }, []);

  //Created By Cursor
  const moveDown = useCallback((index) => {
    setArrangedSubjects((prev) => {
      if (index >= prev.length - 1) return prev;
      const next = [...prev];
      [next[index], next[index + 1]] = [next[index + 1], next[index]];
      return next;
    });
  }, []);

  //Created By Cursor
  const handleClose = useCallback(() => {
    if (saving) return;
    setDraggedIndex(null);
    onHide();
  }, [onHide, saving]);

  //Created By Cursor
  const saveArrangement = useCallback(async () => {
    const schoolCode = SessionManager.getSchoolCode();
    const staffId = SessionManager.getStaffDetails()?.staff_id || "";

    if (!staffId) {
      myToast.notify_error("Staff ID is missing");
      return;
    }
    if (!examId) {
      myToast.notify_error("Exam ID is missing");
      return;
    }
    if (!classItem?.class_id) {
      myToast.notify_error("Class ID is missing");
      return;
    }
    if (!schoolCode) {
      myToast.notify_error("School code is missing");
      return;
    }
    if (!arrangedSubjects.length) {
      myToast.notify_error("No subjects to arrange");
      return;
    }

    const subjectOrderData = arrangedSubjects.map((subject, index) => ({
      subject_id: subject.subject_id,
      display_order: index + 1,
    }));

    setSaving(true);
    try {
      const response = await axios.get(`${API_BASE()}UpdateSubjectOrder.php`, {
        params: {
          staff_id: String(staffId),
          exam_id: String(examId),
          class_id: String(classItem.class_id),
          section_id: String(classItem.section_id || "No"),
          school_code: String(schoolCode),
          subject_order: JSON.stringify(subjectOrderData),
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Subject arrangement saved successfully!");
        const orderedIds = arrangedSubjects.map((s) => s.subject_id);
        if (typeof onSaved === "function") onSaved(orderedIds);
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to save subject arrangement"
        );
      }
    } catch (error) {
      myToast.notify_error(
        error.response?.data?.api_remark || "Error saving subject arrangement"
      );
    } finally {
      setSaving(false);
    }
  }, [arrangedSubjects, classItem, examId, onSaved]);

  const label = useMemo(() => classLabel(classItem), [classItem]);

  if (!show) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      centered
      dialogClassName="mdl-arrange-subject-dialog"
      aria-labelledby="mdl-arrange-subject-title"
    >
      <Modal.Header closeButton={!saving}>
        <div className="mars-title" id="mdl-arrange-subject-title">
          <span className="mars-title__icon" aria-hidden>
            <FaSort />
          </span>
          <div className="mars-title__text">
            <div className="mars-title__main">Arrange Subjects</div>
            <div className="mars-title__sub">
              Reorder subjects for {label}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="mars-meta">
          <span className="mars-pill">
            Class: <strong>{label}</strong>
          </span>
          <span className="mars-pill">
            Subjects: <strong>{arrangedSubjects.length}</strong>
          </span>
        </div>

        <p className="mars-hint">
          Drag and drop, or use arrows, to set the display order.
        </p>

        {arrangedSubjects.length === 0 ? (
          <div className="mars-empty">
            <p className="mars-empty__title">No subjects found</p>
            <p className="mars-empty__hint">
              Add subjects to this class before arranging.
            </p>
          </div>
        ) : (
          <div className="mars-list" onDragOver={handleDragOver}>
            {arrangedSubjects.map((subject, index) => (
              <div
                key={subject.subject_id || index}
                className={`mars-item${
                  draggedIndex === index ? " is-dragging" : ""
                }`}
                draggable={!saving}
                onDragStart={(e) => handleDragStart(e, index)}
                onDragEnd={handleDragEnd}
                onDrop={(e) => handleDrop(e, index)}
              >
                <span className="mars-item__grip" aria-hidden>
                  <FaGripVertical />
                </span>
                <span className="mars-item__order">{index + 1}</span>
                <span className="mars-item__body">
                  <span className="mars-item__name">{subject.subject_name}</span>
                  {subject.subject_code ? (
                    <span className="mars-item__code">
                      {subject.subject_code}
                    </span>
                  ) : null}
                </span>
                <div className="mars-item__actions">
                  <button
                    type="button"
                    className="mars-move"
                    onClick={() => moveUp(index)}
                    disabled={saving || index === 0}
                    title="Move up"
                    aria-label="Move up"
                  >
                    <FaArrowUp aria-hidden />
                  </button>
                  <button
                    type="button"
                    className="mars-move"
                    onClick={() => moveDown(index)}
                    disabled={
                      saving || index === arrangedSubjects.length - 1
                    }
                    title="Move down"
                    aria-label="Move down"
                  >
                    <FaArrowDown aria-hidden />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="mars-btn mars-btn--ghost"
          onClick={handleClose}
          disabled={saving}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mars-btn mars-btn--primary"
          onClick={saveArrangement}
          disabled={arrangedSubjects.length === 0 || saving}
        >
          <FaCheck aria-hidden />
          {saving ? "Saving…" : "Save Arrangement"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlArrangeSubjects;
